const SKIP_KEYS = new Set(['usageMetadata']);

function walk(value: unknown, out: Set<string>): void {
  if (value == null) return;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    const text = String(value).trim();
    if (text) out.add(text);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item) => walk(item, out));
    return;
  }
  if (typeof value === 'object') {
    Object.entries(value).forEach(([key, item]) => {
      if (!SKIP_KEYS.has(key)) walk(item, out);
    });
  }
}

/** Unique printable field values from an extraction result, for one locate call. */
export function collectLocateTexts(result: unknown): string[] {
  const out = new Set<string>();
  walk(result, out);
  return [...out];
}
